import { Injectable } from '@angular/core';
import { State, Selector, StateContext } from '@ngxs/store';
import { BazaNcBootstrapDto } from '@scaliolabs/baza-nc-shared';
import { AccountState } from '../account';
import { Account } from '../../models';
import { BootstrapState } from '../bootstrap';

@State({
    name: 'DividentAlert',
})
@Injectable()
export class DividendAlertState {
    @Selector([AccountState.account, BootstrapState.initData])
    static show(_: StateContext<unknown>, account: Account, initData: BazaNcBootstrapDto): boolean {
        return (
            (account &&
                initData?.investorAccount?.status?.isDwollaAvailable &&
                !initData.investorAccount?.isBankAccountCashOutLinked &&
                initData.isAnyAssetPurchased) ??
            false
        );
    }
}
